import styles from "./guard-item-detail.module.scss";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useState, useEffect } from "react";
import { AppBar, IconButton, Toolbar } from "@material-ui/core";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import deviceIcon from "assets/images/device-icon.svg";
import zoneIcon from "assets/images/zone-house-icon.svg";
import commentIcon from "assets/images/comment-icon.svg";
import Loader from "components/MainApp/atoms/Loader";
import { ProductService } from "services/ProductService";
import AlertDetailCard from "components/MainApp/atoms/AlertDetailCard/AlertDetailCard";
import AlertProductDetail from "components/MainApp/atoms/AlertProductDetail/AlertProductDetail";
import ModalProcessAlert from "components/MainApp/organisms/Modals/ModalProcessAlert/ModalProcessAlert";
import useWindowSize from "hooks/useWindowSize";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const GuardItemDetail = ({ alert, setAlert, reloadAlerts }) => {
  const { isMobile } = useWindowSize();
  const [product, setProduct] = useState(null);
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);

  const tag = alert.tag;
  const device = alert.device;

  const alarmDetailContent = [
    { icon: deviceIcon, label: i18n.t("device"), value: device?.name },
    { icon: zoneIcon, label: i18n.t("site"), value: device?.location.path_name },
    { icon: commentIcon, label: i18n.t("comment"), value: alert?.comments }
  ];

  const handleBackDetail = () => {
    setAlert(null);
  };

  const handleBack = () => {
    setIsOpenPopUp(false);
  };

  const handleClose = () => {
    handleBack();
    setAlert(null);
  };

  useEffect(() => {
    if (alert?.tag) {
      ProductService.productBySKU(alert.tag.sku).then(prod =>
        setProduct(prod.results.results[0])
      );
    }

    if (alert && !alert?.tag) {
      setTimeout(() => {
        setAlert(null);
      }, 1000);
    }
  }, [alert]);

  return (
    <div className={styles["guard-item-detail"]}>
      {!product && <Loader />}

      <AppBar position="static" className={styles["appBarMui"]} elevation={0}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleBackDetail}
            aria-label={i18n.t("close")}
          >
            <ArrowBackIcon />
          </IconButton>
          <div className={styles["header-tittle"]}>{i18n.t("alert.detail")}</div>
        </Toolbar>
      </AppBar>

      <AlertDetailCard content={alarmDetailContent} alert={alert} />

      <AlertProductDetail
        tag={tag}
        product={product}
        processAlert={() => setIsOpenPopUp(true)}
      />

      {isMobile && (
        <div className={styles["alert-process-mobile"]}>
          <button onClick={() => setIsOpenPopUp(true)}>{i18n.t("process.alarm")}</button>
        </div>
      )}

      <ModalProcessAlert
        isOpen={isOpenPopUp}
        alert={alert}
        handleBack={handleBack}
        handleClose={handleClose}
        reloadAlerts={reloadAlerts}
      />
    </div>
  );
};

export default GuardItemDetail;
